import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Org } from 'modules/Org/Org'
import { Device } from 'modules/Device/Device'
import { OrgGroup } from 'modules/OrgGroup/OrgGroup'
import { Tenant } from 'modules/Tenant/Tenant'

export class Reseller extends Model {
  static override entity = 'resellers'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare address: string | null
  @Attr(true) declare active: boolean

  @HasMany(() => Org, 'org_id') declare orgs: Org[]
  @HasMany(() => Device, 'device_id') declare devices: Device[]
  @HasMany(() => OrgGroup, 'org_group_id') declare orgGroups: OrgGroup[]

  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
}
